export const accountKeys = {
  sessions: () => ['me', 'sessions'] as const,
};
